// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-layout {
  display: flex;
  height: 100vh;
  overflow-y: hidden;
}

.content {
  display: flex;
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}

.main-content {
  flex-grow: 1;
  overflow-y: auto;
}

.note-editor-container {
  font-family: "Arial", sans-serif;
  background-color: #f3e8a99d;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  width: 30%; /* Prendre environ 1/4 de la largeur */
  overflow: auto;
  margin-left: 5px;
}

.main-content.with-editor {
  width: 75%; /* Réduire la largeur lorsque le NoteEditor est ouvert */
}

.eye-slash-icon {
  color: red;
  font-size: 24px;
  transition: transform 0.3s ease-in-out;
}

.eye-slash-icon:hover {
  transform: scale(1.5);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RootLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;EACtB,UAAU,EAAE,sCAAsC;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU,EAAE,wDAAwD;AACtE;;AAEA;EACE,UAAU;EACV,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".root-layout {\n  display: flex;\n  height: 100vh;\n  overflow-y: hidden;\n}\n\n.content {\n  display: flex;\n  flex-grow: 1;\n  overflow-y: auto;\n  position: relative;\n}\n\n.main-content {\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n.note-editor-container {\n  font-family: \"Arial\", sans-serif;\n  background-color: #f3e8a99d;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  width: 30%; /* Prendre environ 1/4 de la largeur */\n  overflow: auto;\n  margin-left: 5px;\n}\n\n.main-content.with-editor {\n  width: 75%; /* Réduire la largeur lorsque le NoteEditor est ouvert */\n}\n\n.eye-slash-icon {\n  color: red;\n  font-size: 24px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.eye-slash-icon:hover {\n  transform: scale(1.5);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
